<template>
  <div class="text-md">
    <h1 class="h1 text-bold text-uppercase p-b-1 m-0">
      About Us
    </h1>

    <section>
      <AboutSectionHeading>
        Our Mission
      </AboutSectionHeading>
      <p>
        At Pro Referral, our mission is simple. We aim to provide a seamless, reliable experience
        by connecting quality pros with homeowners looking to create the perfect home.
      </p>
    </section>

    <section>
      <AboutSectionHeading>
        What We Do
      </AboutSectionHeading>
      <p>
        For customers who are in need of someone that knows how to install that ceiling fan, fix
        that electrical socket, paint the exterior of their home, or even clean out the gutters,
        but aren’t sure where to go for help—this is where Pro Referral comes in.
      </p>
      <p>
        Powered by The Home Depot, Pro Referral uses the latest technology to match our customers,
        both online and in-store, with local pros. Pro Referral is the ultimate marketplace for our
        customer’s home improvement needs.
      </p>
    </section>

    <section>
      <AboutSectionHeading>
        Who We Are
      </AboutSectionHeading>
      <p>
        Our company was founded as Redbeacon in 2008, and went on to win the 2009 TechCrunch 50 and
        the 2010 SAI Startup. Impressed by the impact Redbeacon was having on the booming home
        services industry, The Home Depot acquired Redbeacon in 2012. In March of 2016, Redbeacon
        evolved into Pro Referral, and now works to better serve our customers.
      </p>
    </section>

  </div>
</template>

<script>
import AboutSectionHeading from '../../AboutSectionHeading';

export default {
  name: 'about-us',
  metaInfo: {
    title: 'About Us',
  },
  components: {
    AboutSectionHeading,
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  p {
    @include padding-bottom(1);
  }
</style>
